<div class="mx-auto w-full max-w-2xl">
  <canvas
    baseChart
    [data]="barChartData"
    [type]="barChartType"
    [options]="barChartOptions">
  </canvas>
</div>
